import axios from "axios";
import { API_BASE_URL } from "../../../config";


export const getMarkBusinessUserMsg = async (conversationId, currentBusinessUserId) =>
{
    try
    {
        const response = await axios.get(`${API_BASE_URL}/api/Chat/MarkBusinessUserMessageAsRead`, {
            params: {
                conversationId,
                currentBusinessUserId
            },
        });
        return response.data;
    } catch (error)
    {
        console.error("Error fetching MarkBusinessUserMessageAsRead:", error);
        throw error;
    }
};
